/** Level 3, Lessons 19–20 — the cumulative reviews (lesson19_review1.tex, lesson20_review2.tex). No new skills:
 * every section names the lesson it comes from, so a student who misses a few knows exactly where to go back. */
import type { Lesson, Step } from "../types";

const sec = (id: string, title: string, from: string, skill: string, min = 3): Step => ({
  kind: "practice", id, title: `${title} — from ${from}`, intro: `Miss a few here? Go back to ${from} and sharpen it — that is exactly what these pages are for.`, skill, mastery: { min, need: min, window: min + 1 },
});

export const L3_LESSON19: Lesson = {
  id: "L3.19", level: "3", num: 19, title: "Cumulative Review — Part 1",
  blurb: "numbers & operations · every section names its lesson",
  steps: [
    sec("tables", "The tables and division", "Lessons 1–8", "facts-mixed", 6),
    sec("round", "Rounding", "Lesson 1", "round-line"),
    sec("add3", "Adding", "Lesson 2", "add-3digit-vertical"),
    sec("sub3", "Subtracting", "Lesson 2", "sub-3digit-vertical"),
    sec("dist", "The distributive property", "Lesson 4", "distributive-split"),
    sec("tens", "Multiplying by tens", "Lesson 5", "times-tens"),
    sec("groups", "Arrays and equal groups", "Lesson 7", "equal-groups-word"),
    sec("missing", "Missing numbers", "Lesson 7", "missing-factor"),
    sec("clock", "Telling time", "Lesson 6", "clock-read-minute"),
    sec("elapsed", "Elapsed time", "Lesson 9", "elapsed-time"),
    sec("pattern", "Patterns in the tables", "Lesson 7a", "l3-pattern"),
    sec("divstory", "Division stories", "Lesson 8a", "div-story"),
    sec("twostep", "Two-step stories", "Lesson 8a", "two-step"),
    sec("mv", "Liquid volume and mass", "Lesson 9a", "mv-word"),
  ],
};

export const L3_LESSON20: Lesson = {
  id: "L3.20", level: "3", num: 20, title: "Cumulative Review — Part 2",
  blurb: "fractions, measurement & geometry",
  steps: [
    sec("fread", "Equal parts", "Lesson 10", "frac-read"),
    sec("fline", "The number line", "Lesson 11", "frac-line-read"),
    sec("fcomp", "Comparing fractions", "Lesson 12", "frac-compare", 4),
    sec("fequiv", "Equivalent fractions", "Lesson 13", "frac-equivalent"),
    sec("fwhole", "Whole numbers as fractions", "Lesson 13a", "frac-whole"),
    sec("area", "Area", "Lesson 14", "area-sides"),
    sec("perim", "Perimeter", "Lesson 15", "perimeter-rect"),
    sec("lshape", "Area puzzles", "Lesson 15a", "area-rectilinear"),
    sec("poly", "Polygons", "Lesson 16", "polygon-name"),
    sec("quad", "The quadrilateral family", "Lesson 16", "quad-rule"),
    sec("graph", "Bar graphs", "Lesson 18", "bar-graph"),
    sec("pic", "Picture graphs", "Lesson 18a", "picture-graph"),
    sec("plot", "Measuring and line plots", "Lesson 18a", "line-plot-inch"),
    sec("tables", "The tables and division", "Lessons 1–8", "facts-mixed", 6),
  ],
};
